module.exports = __webpack_public_path__ + "media/images/WFC_Award_White-aae3804ee7be6ebdcde89427f83a480b.svg";